import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { TournamentsService } from './../tournaments/services/tournaments.service';

declare let $;

declare let JsBarcode: any;

declare let SetLanguage: any;
@Component({
    selector: 'comp_print_lastPayout',
    templateUrl: './print_lastPayout.html',
})
export class PrintLastPayout implements OnInit {
    constructor(public tournamentsService: TournamentsService) {
        SetLanguage('', '');
    }
    init: boolean;
    ngOnInit() {
        SetLanguage('', '');
        if (this.init) return;
        this.init = true;
    }
    LastPayoutControlModal_Button_No() {
        $('#LastPayoutControlModal').modal('hide');
    }
}
